import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface PylonWidgetPosition {
  x: number;
  y: number;
}

interface PylonWidgetStore {
  position: PylonWidgetPosition;
  setPosition: (position: PylonWidgetPosition) => void;
  resetPosition: () => void;
}

// {0, 0} is no translate offset, leaving Pylon's natively-rendered
// bottom-right bubble in place. Scoping persistence to sessionStorage means
// each browser session starts at this default — drags only stick for the
// current tab, not across sessions.
const DEFAULT_POSITION: PylonWidgetPosition = { x: 0, y: 0 };

export const usePylonWidgetStore = create<PylonWidgetStore>()(
  persist(
    (set) => ({
      position: DEFAULT_POSITION,
      setPosition: (position) => set({ position }),
      resetPosition: () => set({ position: DEFAULT_POSITION }),
    }),
    {
      name: "pylon-widget-store",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
